import React from 'react'
import { Route, BrowserRouter as Router, Switch, Link } from 'react-router-dom'
import './style.css'
import Topic from "./Topic/";

import firestore from '../../database';

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  render() {
      let router =
          <div>
              <Switch>
                  <Route path='/*/library/:id' component={Topic} />
                  <Route exact path="/youth/library" render={() => {
                      return(
                          <div className="library-container" style={{"paddingTop":"25px"}}>
                            <Books />
                          </div>
                      )
                  }} />
              </Switch>
          </div>;
      return (
          <Router>
              <div>
                  {router}
              </div>
          </Router>
      );
    }

}

class Books extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      books : []
    }
  }
  
  componentDidMount() {
    this.getYouthSection();
  }

  render() {
    if (this.state.books.length > 1) {
      return (
        <div>
          {this.state.books.map(doc => {
            return (
              <Link to={"library/" + doc.id}>
                <img className='book-icon' src={doc.data().image} alt={doc.data().title} />
              </Link>
            );
          })}
        </div>
      )
    } else {
      return (  
        <div>
          Empty
        </div>
      )
    }
  }

  async getYouthSection() {
    const ref = firestore.collection("/learnSections");
    const youthQuery = await ref.where("youth", '==', true).get();
    console.log(youthQuery.size);

    let Books = []

    youthQuery.forEach(element => {
      Books.push(element)
    });


    this.setState({books : Books})
    console.log(this.state.books)
  }
}




// WEBPACK FOOTER //
// ./src/components/Library/index.js